export default {
    duration: 'Длительность',
    start: 'Начало',
    end: 'Окончание',
};
